export const getAdeptLevel = (legend: {low: number, mid: number}, unitValue: string | number) => {
  const { low, mid } = legend;
  if (+unitValue <= low) return 'low';
  if (+unitValue <= mid) return 'mid';
  return 'high';
};
